import { StackProps, Text, VStack, Wrap } from "@chakra-ui/react";
import { ProgressStatusProfile } from "../slider/ProgressStatusProfile";
import { ProfileCompleteCard } from "./ProfileCompleteCard";

interface Props extends StackProps {
  title?: string;
  countProgress: number;
  statusProfile: any[] | undefined;
}

export const ProfileProgress = ({
  title = "Kelengkapan Profil",
  countProgress,
  statusProfile,
}: Props) => {
  const sortedProfiles = statusProfile?.slice().sort((a, b) => {
    return a.isComplete === b.isComplete ? 0 : a.isComplete ? -1 : 1;
  });

  return (
    <VStack w={"100%"} p={4} borderRadius={"md"} align={"center"}>
      <Text textStyle={"h-title"} textAlign={"center"}>
        {title}
      </Text>

      <ProgressStatusProfile countProgress={countProgress} />

      <Wrap spacing={2} mt={6} justify={"center"}>
        {sortedProfiles &&
          sortedProfiles.map((profile: any) => (
            <ProfileCompleteCard
              key={profile.id}
              title={profile.name}
              isComplete={profile.isComplete}
            />
          ))}
      </Wrap>
    </VStack>
  );
};
